import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  roomEntranceStateRecoil,
} from '../../atom/ModalAtom';
import { userIdState } from '../../atom/TokenAtom';
import { RoomPasswordDto } from '../../model/room.dto';
import { roomAPI } from '../../api/axiosIndex';

interface RoomEntranceProps {
  roomId: number;
}

const RoomEntrance = ({ roomId }: RoomEntranceProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const navigate = useNavigate();

  const setModalState = useSetRecoilState(roomEntranceStateRecoil);

  const [mainPassword, setMainPassword] = useState('');
  const [subPassword, setSubPassword] = useState('');

  const mainPasswordRef = useRef<HTMLInputElement>(null);
  const subPasswordRef = useRef<HTMLInputElement>(null);

  const onChangeMainPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setMainPassword(inputValue);
    if (inputValue.length > 0) {
      if (subPasswordRef.current) subPasswordRef.current.disabled = true;
    } else if (inputValue.length === 0) {
      if (subPasswordRef.current) subPasswordRef.current.disabled = false;
    }
  };

  const onChangeSubPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setSubPassword(inputValue);
    if (inputValue.length > 0) {
      if (mainPasswordRef.current) mainPasswordRef.current.disabled = true;
    } else if (inputValue.length === 0) {
      if (mainPasswordRef.current) mainPasswordRef.current.disabled = false;
    }
  };

  const handleConfirm = async () => {
    if (mainPassword === '' && subPassword === '') {
      setError(blankMsg);
      return;
    }

    try {
      const formDate: RoomPasswordDto = {
        belongedPassword: mainPassword,
        borrowedPassword: subPassword,
      };
      await roomAPI.roomEntry(roomId, formDate);
      navigate(`/roomdetail/${roomId}`);
    } catch (err: any) {
      setError('비밀번호가 일치하지 않습니다.');
    }

    setModalState(false);
  };

  return (
    <>
      <InputModal
        title="방 입장"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>고정 비밀번호</h2>
            <CS.TextInputType1
              type="password"
              placeholder="고정 비밀번호 입력"
              value={mainPassword}
              onChange={onChangeMainPassword}
              ref={mainPasswordRef}
              aria-label="고정 비밀번호 입력 필드"
            />
          </li>
          <li>
            <h2>용차 비밀번호</h2>
            <CS.TextInputType1
              type="password"
              placeholder="용차 비밀번호 입력"
              value={subPassword}
              onChange={onChangeSubPassword}
              ref={subPasswordRef}
              aria-label="용차 비밀번호 입력 필드"
            />
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default RoomEntrance;
